import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalType } from '@app/shared/models/modal.model';
import { ShopOffersItem } from '@app/shared/models/shop-offers.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { Observable } from 'rxjs';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';
import { ShopRatesRepository } from '@app/shared/state/shop-rates/shop-rates.repository';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-slotcard-info-modal',
  templateUrl: './slotcard-info.component.html',
  styleUrls: ['./slotcard-info.component.scss'],
  standalone: true,
  imports: [SharedModule, NavigationButtonComponent],
})
export class SlotcardInfoModalComponent implements OnInit {
  componentDestroy: () => Observable<unknown>;
  private readonly eventManager = inject(EventManager);
  private readonly shopRatesRepo = inject(ShopRatesRepository);
  protected readonly slotcardInfoModalData = inject<Modal>(MAT_DIALOG_DATA);

  slotcard: LimitedTimeEvent;
  slotcardShopItem: ShopOffersItem;
  slotcardMinPurchase: string;
  slotcardCurrencySymbol: string;

  ngOnInit(): void {
    this.slotcard = this.slotcardInfoModalData.data;
    this.calculateMinPurchase();
  }

  closeModal(): void {
    this.eventManager.closeModal(new Modal(this.slotcardInfoModalData.id, ModalType.View, this.slotcardInfoModalData));
  }

  private calculateMinPurchase(): void {
    this.slotcardShopItem = this.shopRatesRepo
      .getShopRates()
      .Coins?.find((rate) => rate.sku === this.slotcard.properties.sku);
    this.slotcardMinPurchase = this.slotcardShopItem ? this.slotcardShopItem.amount : '0';
    this.slotcardCurrencySymbol = this.slotcardShopItem ? this.slotcardShopItem.currencySymbol : '';
  }
}
